import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCrmConfig, UpdateCrmConfigProps } from '.';

export function useUpdateCrmConfig(){
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: ['crm_configs'],
        mutationFn: async (data: UpdateCrmConfigProps) => {
            const res = await updateCrmConfig(data);
            if(res.error) throw new Error(res.error.message)
            return res.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['crm_configs'] });
            queryClient.invalidateQueries({ queryKey: ['project', 'list'] });
        }
    })
}

